import { Checkbox } from "@chakra-ui/react";
import React from "react";
import { COMMON_WEB_PATH } from "../../../constant";

const CustomCheckbox = (props) => {
  return (
    <Checkbox
      {...props}
      sx={{
        "& .chakra-checkbox__control": {
          bg: `url(${COMMON_WEB_PATH}/theOne/lng/lng_checkbox.png)`,
          border: "none",
          backgroundImage: `url(${COMMON_WEB_PATH}/theOne/lng/lng_checkbox.png)`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "100% 100%",
          width: "25px",
          height: "25px",
          _checked: {
            bg: `uurl(${COMMON_WEB_PATH}/theOne/lng/lng_checkbox.png)`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "100% 100%",
            width: "25px",
            height: "25px",
            "& div": {
              backgroundImage: `url(${COMMON_WEB_PATH}/theOne/lng/lng_tick.png)`,
              w: "100%",
              bgRepeat: "no-repeat",
              bgSize: "contain",
            },
            "& svg": {
              display: "none",
            },
          },
        },
      }}
    >
      {props.labelText}
    </Checkbox>
  );
};

export default CustomCheckbox;
